<script lang="ts">
  // libs
  import { convertToDistributorDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import ProductTable from "@retailer/svelte/Payments/PaymentDetails/ProductTable.svelte";

  // types
  import type { Invoice } from "@shared/types/Invoice";

  // props
  export let invoice: Invoice;

  // data
  const lineItemsCount = invoice.line_items ? invoice.line_items.length : 0;

  // functions
  const totalQuantityString = total => {
    const itemString = total > 1 ? "Items" : "Item";
    return ` (${total} ${itemString})`;
  };

</script>

<div class="fizz-inset-square-24 fizz-space-between-responsive-8 fizz-border-bottom">
  <p>
    <strong>Credit Summary</strong>
    {#if lineItemsCount != 0}{totalQuantityString(lineItemsCount)}{/if}
  </p>
</div>

<div
  class="fizz-flex-row-responsive fizz-space-between fizz-text-medium fizz-align-content-start fizz-inset-squish-24"
>
  <p>
    <strong>Invoice Number:</strong><br />
    {"#" + invoice.invoice_reference_id}
  </p>
  <p>
    <strong>Credited to:</strong><br />
    {invoice.retailer.name}<br />
    {invoice.retailer.address1}{#if invoice.retailer.address2},{/if}
    {invoice.retailer.address2 || ""}
  </p>
  <p class="fizz-hide-on-large">
    <strong>Credit issued:</strong><br />
    {convertToDistributorDate(invoice.issue_date)}
  </p>
  <p class="fizz-text-right fizz-hide-on-small">
    <strong>Credit issued:</strong><br />
    {convertToDistributorDate(invoice.issue_date)}
  </p>
</div>
<div class="fizz-inset-square-24 fizz-full-width fizz-surface-blue fizz-hide-on-large">
  <p class="fizz-text-strong">Invoice Details</p>
</div>

<ProductTable {invoice} />

<div class="fizz-flex-row fizz-justify-end fizz-stack-32 fizz-inset-horizontal-24">
  <table class="fizz-text-medium fizz-table-compact" style="max-width: 320px;">
    <tbody>
      <tr>
        <th>Credit Total</th>
        <td class="fizz-align-right">
          <strong data-testid={"total-credit-amount"}>
            <FormatMoney input={parseFloat(invoice.original_amount_due)} formatType={"5"} />
          </strong>
        </td>
      </tr>
    </tbody>
  </table>
</div>
